import { Component } from 'react'

export default class HomeController extends Component {
  constructor() {
    super()
    document.getElementsByTagName('html')[0].classList.remove('a-fullscreen')
  }
}